<template>
  <div class="actions">
    <div v-if="candidateStatus.id == namedStatuses.accept" class="response-status custom-label">
      {{ $tr('common.list.status') }}: {{ $tr('responses.statuses.accept') }}
    </div>

    <div v-else-if="candidateStatus.id == namedStatuses.refuse" class="response-status custom-label">
      {{ $tr('common.list.status') }}: {{ $tr('responses.statuses.refuse') }}
    </div>

    <template v-else-if="!isRoleRead">
      <button
        :class="[
          'vcv-button iconed transparent green',
          {
            disabled: admin_token && isCreatedByAdmin && !isSuperAdmin
          }
        ]"
        @click="setStatus({ id: namedStatuses.accept })"
      >
        <img src="/static/icons/icon_like.svg" alt="icon-like" />
        <span>{{ $tr('actions.invite') }}</span>
      </button>

      <button
        :class="[
          'vcv-button iconed transparent red dislike',
          {
            disabled: admin_token && isCreatedByAdmin && !isSuperAdmin
          }
        ]"
        @click="setStatus({ id: namedStatuses.refuse })"
      >
        <svg
          width="21"
          height="21"
          viewBox="0 0 21 21"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          class="icon-dislike"
        >
          <path
            d="M12.6325 3.21094H5.13249C4.44082 3.21094 3.84915 3.6276 3.59915 4.2276L1.08249 10.1026C1.00749 10.2943 0.96582 10.4943 0.96582 10.7109V12.3026L0.974154 12.3109L0.96582 12.3776C0.96582 13.2943 1.71582 14.0443 2.63249 14.0443H7.89082L7.09915 17.8526L7.07415 18.1193C7.07415 18.4609 7.21582 18.7776 7.44082 19.0026L8.32415 19.8776L13.8158 14.3859C14.1158 14.0859 14.2992 13.6693 14.2992 13.2109V4.8776C14.2992 3.96094 13.5492 3.21094 12.6325 3.21094ZM15.9658 3.21094V13.2109H19.2992V3.21094H15.9658Z"
            fill="currentColor"
          />
        </svg>
        <span>{{ $tr('actions.refuse') }}</span>
      </button>

      <additional-buttons class="additional-buttons" :response="response" />
    </template>

    <multiselect
      v-model="candidateStatus"
      class="multiselect__flex"
      :options="statuses"
      :show-labels="false"
      :allow-empty="false"
      searchable
      track-by="id"
      label="name"
      :class="['big', { disabled: disableActions }]"
      :placeholder="$tr('responses.placeholders.statusFilter')"
    />

    <vbutton
      v-tooltip.top-center="$tr('common.iconTooltips.sendLinkToCandidate')"
      icon="icon_share_new"
      color="grey"
      type="icon"
      :disabled="loadingCompanyUsers"
      @click="$emit('change-link-share-display')"
    />
  </div>
</template>

<script>
import { mapActions } from 'vuex';
import { getCookie } from 'tiny-cookie';
import Statuses from '@/components/response/statuses';
import AdditionalButtons from '@/components/response/actions/index';

const STATUS_NEW_ID = 1;
const STATUS_WAITING_DECISION_ID = 2;

export default {
  name: 'CandidateActionsDefault',

  components: {
    AdditionalButtons
  },

  mixins: [Statuses],

  props: {
    response: Object,
    fetch: Function,
    changeSendMessageDisplay: Function
    // changeLinkShareDisplay: Function
  },

  computed: {
    loadingCompanyUsers() {
      return this.$store.state.users.loading;
    },

    statuses() {
      return this.$store.getters['dictionary/responseStatuses']
        .filter(i => parseInt(i.id) !== STATUS_NEW_ID)
        .filter(i => (this.isRoleRead ? !i.is_base : true))
        .filter(i => !i.is_system);
    },

    is_test() {
      return this.$store.getters['user/company'] ? this.$store.getters['user/company'].is_test : false;
    },

    admin_token() {
      const localStorage_admin_token = window.localStorage.admin_token
        ? JSON.parse(window.localStorage.admin_token)
        : null;
      const cookie_admin_token = getCookie('admin_token') ? JSON.parse(getCookie('admin_token')) : null;
      return localStorage_admin_token || cookie_admin_token;
    },

    isSuperAdmin() {
      return this.admin_token ? this.has_role('ROLE_ADMIN_SUPER') : false;
    },

    userIsCompanyAdmin() {
      return this.$store.getters['user/isCompanyAdmin'];
    },

    userIsCompany() {
      return this.$store.getters['user/isCompanyUser'];
    },

    isCreatedByAdmin() {
      return this.$store.getters['user/isCreatedByAdmin'];
    },

    candidateStatus: {
      get() {
        return this.response.status;
      },

      set(val) {
        this.setStatus(val);
      }
    },

    isRoleRead() {
      if (!this.response || !this.response.vacancy) {
        return false;
      }

      return this.response.vacancy.role === 'role_read';
    },

    disableActions() {
      return this.admin_token && this.isCreatedByAdmin && !this.is_test && !this.isSuperAdmin;
    }
  },

  beforeMount() {
    if (parseInt(this.response.status.id) === STATUS_NEW_ID && !this.admin_token) {
      this.setStatus({ id: STATUS_WAITING_DECISION_ID });
    }
    // Fetch company users to share link email list
    this.$store.dispatch('users/fetchUsersDropdown');
  },

  methods: {
    ...mapActions('response', ['fetchResponseHistory']),

    has_role(needed) {
      if (this.admin_token) {
        return this.admin_token.user.roles.some(({ role }) => role === needed);
      }

      return false;
    },

    setStatus(status) {
      if (!status) return;

      const model = {
        id: this.response.id,
        status: { id: status.id }
      };

      this.$emit('on-status-change', model);

      // this.$store.dispatch('response/saveQuietly', model)
      //   .then(data => {
      //     this.$emit('onStatusChange')
      //   })
    }
  }
};
</script>

<style lang="scss" scoped>
.actions {
  display: flex;
  margin-bottom: 10px;
  flex: 1;
  position: relative;
  justify-content: space-between;
  z-index: 199;

  .vcv-button {
    display: flex;
    justify-content: center;
    align-items: center;
    margin-right: 11px;
    text-transform: none;
    font-weight: 500;
    line-height: 20px;
    padding-top: 8px;

    &.iconed span {
      margin-left: 9px;
    }

    img {
      width: 22px;
      height: 21px;
    }

    &.green {
      border-color: $green !important;
      background: $green !important;
      color: #fff !important;

      &:hover {
        border-color: $green-hover !important;
        background: $green-hover !important;
      }

      &:active {
        border-color: $blue !important;
        background: $blue !important;
      }
    }

    &.red {
      border-color: $red !important;
      background: #fff !important;
      color: $red !important;

      &:hover {
        border-color: $red-light !important;
        color: $red-light !important;
      }

      &:active {
        border-color: $red !important;
        color: $red !important;
      }
    }
  }

  .response-status {
    white-space: nowrap;
    padding-right: 20px;
  }

  .disabled {
    opacity: 0.3;
    cursor: not-allowed;
    pointer-events: none;
    background: #f1f2f2;
    color: #555;
    border: 1px solid #e5e5e5;
  }

  & > a,
  & > div:not(.additional-buttons) {
    margin-right: 10px;
  }

  .multiselect__flex {
    max-width: none;
    flex: 1;
  }
}

.status-button {
  display: flex;
  align-items: center;

  img {
    margin-right: 6px;
  }
}
</style>
